import React, { Fragment } from 'react';
import './Pricing.scss';
import Boost from '../../components/Boost/index';

// IMAGES
import growTogether from '../../images/illustration-grow-together.svg';

export default function Pricing() {
  return (
    <Fragment>
      <header className='pricing-header'>
        <img
          className='pricing-header__img'
          src={growTogether}
          alt='people interacting with screens'
        />
        <div className='pricing-header__text'>
          <h1 className='pricing-header__h1'>Power your business</h1>
          <h2 className='pricing-header__h2'>
            Our pricing plans provide solutions for endeavors at any scale.
          </h2>

          <a href='#pricing'>
            <button className='btn'>Get Started</button>
          </a>
        </div>
      </header>

      <main className='pricing'>
        <div className='pricing__heading-container' id='pricing'>
          <h3>From Free to Enterprise</h3>
          <p className='pricing__heading-text'>
            Whether you want to test out our services or design your own
            solution, we're here for you.
          </p>
        </div>
        <div className='pricing__containers'>
          <div className='pricing__container first-container'>
            <h3 className='container__header'>Free</h3>
            <p className='container__price'>$0 per month</p>
            <p>
              Start tracking and monitoring audience interactions with custom
              links.
            </p>
            <button className='btn not-active'>Start for Free</button>
          </div>
          <div className='container__line'></div>
          <div className='wrapper'>
            <div className='pricing__container second-container'>
              <h3 className='container__header'>Classic</h3>
              <p className='container__price'>$19 per month</p>
              <p>
                Boost engagement and trust with branded links you create and
                share.
              </p>
              <button className='btn not-active'>Get Started</button>
            </div>
          </div>
          <div className='container__line'></div>
          <div className='pricing__container third-container'>
            <h3 className='container__header custom'>Custom</h3>
            <p className='container__price'>Varies per plan</p>
            <p>
              Choose just the services you need for a price that fits your
              budget.
            </p>
            <button className='btn not-active'>Customize</button>
          </div>
        </div>
      </main>

      <Boost />
    </Fragment>
  );
}
